import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RegistrationFooterComponent } from './registration-footer.component'
import { RouterModule } from '@angular/router'
import { LocalesModule } from '@app/shared/services/locales'
import { SubdomainLinkModule } from '@app/shared/directives/subdomain-link'

export { RegistrationFooterComponent }

@NgModule({
  imports: [CommonModule, RouterModule, LocalesModule, SubdomainLinkModule],
  declarations: [RegistrationFooterComponent],
  exports: [RegistrationFooterComponent],
  providers: [],
})
export class RegistrationFooterModule {}
